import crypto from './assests/crypto-1.png'
import TaskManager from './assests/todo-1.png'
import game from './assests/game-1.png'
import maxxcoffee from './assests/maxxcoffee.png'
import Ahil from './assests/Ahil-1.png'
import gamershow from './assests/gamershow-1.png'
import reactLogo from './assests/icons8-react-native-48.png'
import htmlLogo from './assests/icons8-html5-48.png'
import javascriptLogo from './assests/icons8-javascript-50.png'
import typecriptLogo from './assests/icons8-typescript-48.png'
import tailwind from './assests/icons8-tailwind-css-48.png'
import sassLogo from './assests/icons8-sass-48.png'
import materialLogo from './assests/icons8-material-ui-48.png'
import apiLogo from './assests/icons8-rest-api-50.png'
import cssLogo from './assests/icons8-css-48.png'
import figmaLogo from './assests/icons8-figma-48.png'
import reduxLogo from './assests/icons8-redux-50.png'
import mongoLogo from './assests/icons8-mongo-db-48.png'
import firebaseLogo from './assests/icons8-firebase-48.png'
import nextLogo from './assests/Next.Js-Logo--Streamline-Ultimate.png'
import gitLogo from './assests/icons8-git-48.png'

export const project = [
    {
        id: 1,
        src: gamershow,
        title: 'Gamer show',
        alt: 'gamer show image',
        github: 'https://github.com/armandrik/GamerShow',
        demo: 'https://gamershow.netlify.app/',
        ModalTitle: "GamerShow - Next.js game store",
        describe: ["This fullstack web application is built with Next.js 14 and TypeScript, ensuring a scalable and maintainable codebase.", "Utilizes MongoDB for data storage, with well-structured schemas and models for users, products, comments, and articles, along with defined relationships between them.", "API routes handle authentication using JWT, implementing both access and refresh tokens for enhanced security.", "Certain routes are protected, ensuring only authenticated users can access them.", "Users can manage their cart, view their selected items, and see the final order price dynamically."],
        tech: [nextLogo,mongoLogo,reactLogo,typecriptLogo, tailwind, apiLogo, figmaLogo]
    },
    {
        id: 2,
        src: maxxcoffee,
        title: 'Maxx Coffee',
        alt: 'maxx coffee image',
        github: 'https://github.com/armandrik/maxxCoffee',
        demo: 'https://maxxcoffee.netlify.app/',
        ModalTitle: "Maxx coffee - React.js Coffee Store",
        describe: ["The codebase is developed with TypeScript, ensuring type safety and reducing potential errors.", "Efficient API communication with Axios, alongside Context API for seamless global state management.", "Secure user authentication, including registration and login, managed through Firebase.", "Tailwind CSS is used to create a responsive and mobile-friendly interface, providing a consistent experience on all devices.", "A modern dark mode design with user preferences saved in localStorage, ensuring the theme persists across sessions."],
        tech: [reactLogo, javascriptLogo, typecriptLogo, tailwind, apiLogo, htmlLogo, figmaLogo]
    },
    {
        id: 3,
        src: game,
        title: 'Game Company',
        alt: 'game company image',
        github: 'https://github.com/armandrik/Game-Company',
        demo: 'https://game-company.netlify.app/',
        ModalTitle: "Game Company - React.js Game Store",
        describe: ["Focused on a compelling UI/UX design using React and SASS. I created smooth animations utilizing the react reveal library", "Ensured a responsive design for optimal user experience."],
        tech: [reactLogo, javascriptLogo, sassLogo, htmlLogo, figmaLogo]
    },
    {
        id: 4,
        src: Ahil,
        title: 'Ahil Landing Page',
        alt: 'Landing page image',
        github: 'https://github.com/armandrik/Ahil-landing-page',
        demo: 'https://ahil.app/',
        ModalTitle: "Ahil Landing Page - React.js and Material Design",
        describe: ["Responsive Landing page for Ahil Application.", "Implemented useContext for adding dark/light mode and i18next for building a bilingual site.", "Utilized React Router Dom", "Ensured a responsive design for optimal user experience."],
        tech: [reactLogo, javascriptLogo, htmlLogo, sassLogo]
    },
    {
        id: 5,
        src: crypto,
        title: 'Crypto Currency',
        alt: 'crepto image',
        github: 'https://github.com/armandrik/React-Crypto-App',
        demo: 'https://react-crypto-currency-drik.netlify.app/',
        ModalTitle: "Crypto Currency - React.js, HTML, and CSS",
        describe: ["real time crypto data that comes from api with axios.", "implemented React router dom, React Alice carousel and chart.js library for display data with different charts that helps user to see several type of data.", "Ensured a responsive design for optimal user experience."],
        tech: [reactLogo, javascriptLogo, htmlLogo, cssLogo, apiLogo]
    },
    {
        id: 6,
        src: TaskManager,
        title: 'Task Manager',
        alt: 'Todo image',
        github: 'https://github.com/armandrik/React-todo',
        demo: 'https://react-todo-app-drik.netlify.app/',
        ModalTitle: "Task Manager - React.js, useReducer",
        describe: ["Task manager implemented with React, useReducer and Material UI.", "Handling actions with useReducer.", "Ensured a responsive design for optimal user experience."],
        tech: [reactLogo, javascriptLogo, materialLogo, htmlLogo, sassLogo]
    },
]

export const album = [
    { id: 12, src: nextLogo, alt: 'next logo' },
    { id: 6, src: reactLogo, alt: 'react logo' },
    { id: 4, src: typecriptLogo, alt: 'typecript logo' },
    { id: 12, src: mongoLogo, alt: 'monogdb logo' },
    { id: 5, src: tailwind, alt: 'tailwind logo' },
    { id: 3, src: javascriptLogo, alt: 'javaScript logo' },
    { id: 8, src: apiLogo, alt: 'restApi logo' },
    { id: 9, src: reduxLogo, alt: 'redux logo' },
    { id: 12, src: firebaseLogo, alt: 'firebase logo' },
    { id: 1, src: htmlLogo, alt: 'html logo' },
    { id: 2, src: cssLogo, alt: 'css logo' },
    { id: 7, src: sassLogo, alt: 'sass logo' },
    { id: 10, src: figmaLogo, alt: 'figma logo' },
    { id: 11, src: materialLogo, alt: 'mui logo' },
    { id: 12, src: gitLogo, alt: 'git logo' },
]

export const famaliar = [
    { id: 1, name: 'Firebase' },
    { id: 2, name: 'Redux' },
    { id: 3, name: 'Figma' },
]

export const skills = [
    { id: 8, skillName: 'Next' ,src:nextLogo},
    { id: 1, skillName: 'React' ,src:reactLogo},
    { id: 3, skillName: 'TypeScript'  ,src:typecriptLogo },
    { id: 2, skillName: 'Javascirpt'  ,src:javascriptLogo},
    { id: 8, skillName: 'MongoDB'  ,src:mongoLogo},
    { id: 4, skillName: 'Tailwind' ,src:tailwind},
    { id: 7, skillName: 'Rest API'  ,src:apiLogo},
    { id: 8, skillName: 'Version Control' ,src: gitLogo},
    { id: 6, skillName: 'Sass' ,src:sassLogo}
]

export const headerItem = [
    { id: 1, item: 'Home', href: '#home' },
    { id: 2, item: 'About', href: '#about' },
    { id: 3, item: 'Skills', href: '#skill' },
    { id: 4, item: 'Latest project', href: '#project' },
    { id: 5, item: 'Contact', href: '#contact' }
]